"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryString = exports.buildUrlWithoutNullishParams = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty2(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context6, _context7; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context6 = ownKeys(Object(t), !0)).call(_context6, function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context7 = ownKeys(Object(t))).call(_context7, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var getQueryString = exports.getQueryString = function getQueryString(params) {
  var _context;
  var esc = encodeURIComponent;
  return (0, _map.default)(_context = (0, _keys.default)(params)).call(_context, function (key) {
    var _context3;
    var item = params[key];
    if ((0, _isArray.default)(item)) {
      return (0, _map.default)(item).call(item, function (param) {
        var _context2;
        return (0, _concat.default)(_context2 = "".concat(esc(key), "=")).call(_context2, esc(param.toString()));
      }).join('&');
    }
    return (0, _concat.default)(_context3 = "".concat(esc(key), "=")).call(_context3, esc(item));
  }).join('&');
};
var isNotNullish = function isNotNullish(item) {
  return !(item === undefined || item === null);
};
var removeUndefinedFromParams = function removeUndefinedFromParams(params) {
  var _context4;
  var queryObj = (0, _reduce.default)(_context4 = (0, _keys.default)(params)).call(_context4, function (prev, key) {
    var item = params[key];
    if ((0, _isArray.default)(item)) {
      var cleanedArray = (0, _filter.default)(item).call(item, isNotNullish);
      if (cleanedArray.length > 0) {
        return _objectSpread(_objectSpread({}, prev), {}, (0, _defineProperty2.default)({}, key, cleanedArray));
      }
      return prev;
    }
    if (!isNotNullish(item)) {
      return prev;
    }
    return _objectSpread(_objectSpread({}, prev), {}, (0, _defineProperty2.default)({}, key, item));
  }, {});
  return (0, _keys.default)(queryObj).length > 0 ? queryObj : undefined;
};
var mapParamsToStrings = function mapParamsToStrings(params) {
  var _context5;
  return (0, _reduce.default)(_context5 = (0, _keys.default)(params)).call(_context5, function (prev, key) {
    var item = params[key];
    if ((0, _isArray.default)(item)) {
      return _objectSpread(_objectSpread({}, prev), {}, (0, _defineProperty2.default)({}, key, (0, _map.default)(item).call(item, function (arrElem) {
        return arrElem.toString();
      })));
    }
    return _objectSpread(_objectSpread({}, prev), {}, (0, _defineProperty2.default)({}, key, item.toString()));
  }, {});
};
var buildUrlWithoutNullishParams = exports.buildUrlWithoutNullishParams = function buildUrlWithoutNullishParams(path, params) {
  var paramsWithoutUndefined = removeUndefinedFromParams(params);
  if (!paramsWithoutUndefined) {
    return path;
  }
  var paramsMappedToStrings = mapParamsToStrings(paramsWithoutUndefined);
  return [path, getQueryString(paramsMappedToStrings)].join('?');
};
//# sourceMappingURL=getQueryString.js.map